import React from "react";
import { VOUCHER_TYPES } from "../data/dummyVoucherData";

export default function VoucherTypeSelector({
  voucherTypes = VOUCHER_TYPES,
  selectedType,
  onSelectType,
}) {
  const displayTypes = voucherTypes && voucherTypes.length > 0 ? voucherTypes : VOUCHER_TYPES;

  return (
    <div className="vch_type_selector_container">
      <label className="vch_label_title">
        Voucher Type <span className="vch_required_star">*</span>
      </label>
      <div className="vch_type_radio_group" role="radiogroup">
        {displayTypes.map((type) => {
          const typeId = type.id || type.vtype || type.name;
          const isSelected =
            selectedType === type.id ||
            selectedType === type.vtype ||
            (typeof selectedType === "string" &&
              selectedType.toLowerCase() === type.name?.toLowerCase());

          return (
            <label
              key={typeId}
              className={`vch_radio_item ${isSelected ? "vch_radio_selected" : ""}`}
              onClick={() => onSelectType(type.id || typeId)}
            >
              <input
                type="radio"
                name="voucherType"
                value={type.id || typeId}
                checked={isSelected}
                onChange={() => onSelectType(type.id || typeId)}
                className="vch_native_radio"
              />
              <span className="vch_custom_radio_circle">
                {isSelected && <span className="vch_radio_dot" />}
              </span>
              <span className="vch_radio_label_text">
                {type.name}{" "}
                {type.code && <span className="vch_key_shortcut">({type.code})</span>}
              </span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
